<template>
    <div class="Box">
        <div>
            <div class="overflow-hidden">
                <div class="z-20 relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8 rounded">
                    <div v-for="(value, index) in definedKeys" :key="index" class="-m-3 p-3 flex items-start space-x-4">
                        <div class="space-y-1">
                            <p class="text-base leading-6 font-bold text-gray-800">
                                {{ summary_map[value] }}
                            </p>
                            <p class="text-sm leading-5 text-gray-800">
                                {{ summary[value] }} 
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Summary",
    props: {
        "summary":  Object
    },
    data() {
        return {
            summary_map: {
                'message_type': 'Message Type',
                'contact_list_type': 'Contact List Type',
                'contact_list_id': 'Contact List',
                'message_recording_type' : 'Message Recording Type',
                'uploaded_audio_file': 'Uploaded Audio File',
                'audio_recording_type': 'Audio Recording Type',
                'text_message': 'Text Message',
            }
        }
    },
    computed: {
        definedKeys() {
            const keyList = [];

            for(const x in this.summary_map) {
                if(this.summary[x] != undefined && this.summary[x] != "") {
                    keyList.push(x);
                }
            }
            return keyList;
        }
    }
}
</script>